
import React from 'react';

interface EventProps {
  date: string;
  month: string;
  title: string;
  description: string;
}

const EventCard: React.FC<EventProps> = ({ date, month, title, description }) => {
  return (
    <div className="flex items-start space-x-6 bg-white p-6 rounded-xl shadow-md hover:shadow-xl transition-shadow duration-300">
      <div className="flex-shrink-0 text-center bg-jskool-red text-white rounded-lg p-3 w-20">
        <p className="font-heading font-black text-4xl">{date}</p>
        <p className="font-bold uppercase tracking-wider">{month}</p>
      </div>
      <div>
        <h3 className="font-heading text-xl font-bold text-jskool-dark">{title}</h3>
        <p className="mt-1 text-jskool-dark/70">{description}</p>
      </div>
    </div>
  );
};

const EventsSection: React.FC = () => {
  return (
    <section id="events" className="py-20 bg-white">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-heading font-extrabold text-jskool-dark">Events & News</h2>
          <p className="mt-4 text-lg text-jskool-dark/70 max-w-3xl mx-auto">
            Stay updated with our latest activities, webinars, and festival celebrations.
          </p>
        </div>
        <div className="space-y-8 max-w-3xl mx-auto">
          <EventCard 
            date="24"
            month="AUG"
            title="Webinar: Ahimsa in the Digital Age"
            description="Exploring non-violence in our online interactions and social media presence."
          />
          <EventCard 
            date="10"
            month="SEP"
            title="Paryushan Parv Special Session"
            description="A guided meditation and lecture series to celebrate the festival of forgiveness."
          />
           <EventCard 
            date="15"
            month="OCT"
            title="Teacher Training: Gamifying Your Pathshala"
            description="Join our workshop to learn how to integrate JSkool's digital tools and gamified lessons into your classroom for a more engaging experience."
          />
          <EventCard 
            date="05"
            month="NOV"
            title="Youth Leadership Workshop"
            description="An interactive workshop for young adults on leading with Jain ethical principles."
          />
        </div>
      </div>
    </section>
  );
};

export default EventsSection;